/**
 * Truncate the middle of a long string with an ellipsis so both the start and
 * the end stay visible — e.g. long filenames keep their extension:
 * "test-post-processors-visual-card-1.png" -> "test-post-pro…l-card-1.png"
 */
const truncateMiddle = (text, maxLength = 32) => {
  if (typeof text !== 'string' || text.length <= maxLength) return text;
  const tail = Math.min(12, Math.floor((maxLength - 1) / 3));
  const head = maxLength - 1 - tail;
  return `${text.slice(0, head)}…${text.slice(text.length - tail)}`;
};

export default truncateMiddle;
